import classes from './ShowCodeBtn.module.css'
import { useSelector } from "react-redux"
import { useNavigate, useParams } from "react-router-dom";
import { onKeyDown } from '../../../../service';
const ShowCodeBtn = ({ ideId, postId }) => {


    const texts = useSelector((state) => state.translate.texts);
    const homeUrl = useSelector(state => state.application.homeUrl);
    const { studyGroupId } = useParams()
    const navigate = useNavigate();

    const handeleOpenProject = () => {
        if (ideId == 1)
            window.location.href = `${homeUrl}/${studyGroupId}/postproject/${postId}`
        else {
            navigate(`${homeUrl}/${studyGroupId}/postproject/${postId}`)
        }
    }

    return (
        <>
            <div className={classes.ViewCodeContainer} onClick={() => handeleOpenProject()} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => handeleOpenProject())}>
                <div className={classes.Icon}></div>
                <div className={classes.ViewCodeText}>{texts.viewCodeClickHere}</div>
            </div>
        </>
    )
}
export default ShowCodeBtn